export const DEFAULT_MESSAGES = Object.freeze({
  ERROR: 'We could not complete your request, please try again later',
});
